import { ManagementCompany } from '../../../packages/ManagementCompany';
import { useSelector } from 'react-redux';
import { Section } from 'shared/components/Section';
import { selectManagementCompany } from 'shared/selectors/managementCompany';

export const ManagementCompanyContainer = () => {
  const managementCompany = useSelector(selectManagementCompany);

  if (!managementCompany) {
    return null;
  }

  return (
    <Section title="Управляющая компания">
      <ManagementCompany data={managementCompany} />
    </Section>
  );
};
